import {LandingNav, AdminNav, AccountNav} from "./navs";
import {NavItem} from "../../interfaces";

export const ADMIN_NAV: NavItem[] = [
  LandingNav.SEARCH,
  {
    path: 'reports',
    label: 'Reports',
    submenus: [
      AdminNav.ADMIN_REPORTS,
      AdminNav.ADMIN_ACCOUNTS,
      AdminNav.ADMIN_BOOKINGS,
      AdminNav.ADMIN_LOCATIONS,
      AdminNav.ADMIN_INVOICES,
      AdminNav.ADMIN_PAYOUTS,
      AdminNav.ADMIN_SPACE_USAGE,
      AdminNav.ADMIN_INTERCHANGES
    ]
  },
  AdminNav.LOGIN_AS_ACCOUNT,
  AccountNav.SIGN_OUT
];
